export default __webpack_public_path__ + "static/poster-pro-sports-2b30ae58efcf25748de77d8f992c2a46.jpg";